import hcAxios from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'
// trade-ws-api-controller
enum API {
  // checkTradeArea
  V3CheckTradeArea = '/hk-web/v3/checkTradeArea',
  // MarketJsons
  V3CollectList = '/hk-web/v3/collect/list',
  // fullDepth
  V3FullDepth = '/hk-web/v3/fullDepth',
  // 根据sellName和buyName获取一条交易对信息,默认获取交易区1中BTC/USDT的交易对信息,如果状态异常则随机取出一条正常的交易对信息
  V3GetOneTradeInfo = '/hk-web/v3/getOneTradeInfo',
  // 获取本周明星币
  V3GetStarCoinThisWeek = '/hk-web/v3/getStarCoinThisWeek',
  // 获取成交额榜
  V3GetTopTurnover = '/hk-web/v3/getTopTurnover',
  // 搜索所有交易区的所有币种
  V3GetTradeTypeBySellName = '/hk-web/v3/getTradeTypeBySellName',
  // 创新区列表
  V3InnovationTradeInfo = '/hk-web/v3/innovationTradeInfo',
  // 主板交易区(app改版)
  V3MarketAreas = '/hk-web/v3/market/areas',
  // MarketJsons
  V3RealMarkets = '/hk-web/v3/real/markets',
  // MarketJson
  V3RealTimeTrade = '/hk-web/v3/realTimeTrade',
  // 根据交易区和交易类型获取交易对成交信息
  V3TradeInfo = '/hk-web/v3/tradeInfo',
  // 获取涨幅或跌幅排行数据
  V3TradeInfoRankingList = '/hk-web/v3/tradeInfoRankingList',
  // 根据sellName和buyName判断是否支持合约/现货/杠杆
  SupportCoinInfo = '/hk-web/support/coin/info',
}

export type TPostV3CheckTradeAreaParams = {
  coinId?: any // coinId
}
export type TPostV3CheckTradeAreaResponse = TResponse<any>
export const postV3CheckTradeArea = (params?: TPostV3CheckTradeAreaParams) => {
  return hcAxios.post<TPostV3CheckTradeAreaResponse>(API.V3CheckTradeArea, params)
}

export type TGetV3CollectListParams = any
export type TGetV3CollectListResponse = TResponse<any>
export const getV3CollectList = (params?: TGetV3CollectListParams) => {
  return hcAxios.get<TGetV3CollectListResponse>(API.V3CollectList, { params })
}

export type TPostV3CollectListParams = any
export type TPostV3CollectListResponse = TResponse<any>
export const postV3CollectList = (params?: TPostV3CollectListParams) => {
  return hcAxios.post<TPostV3CollectListResponse>(API.V3CollectList, params)
}

export type TGetV3FullDepthParams = {
  limit?: any // limit
  tradeId?: any // tradeId
}
export type TGetV3FullDepthResponse = TResponse<any>
export const getV3FullDepth = (params?: TGetV3FullDepthParams) => {
  return hcAxios.get<TGetV3FullDepthResponse>(API.V3FullDepth, { params })
}

export type TPostV3FullDepthParams = {
  limit?: any // limit
  tradeId?: any // tradeId
}
export type TPostV3FullDepthResponse = TResponse<any>
export const postV3FullDepth = (params?: TPostV3FullDepthParams) => {
  return hcAxios.post<TPostV3FullDepthResponse>(API.V3FullDepth, params)
}

export type TGetV3GetOneTradeInfoParams = any
export type TGetV3GetOneTradeInfoResponse = TResponse<{
  buyCoinId?: number
  buyShortName?: string
  buySymbol?: string
  change?: string
  cny?: string
  digit?: string
  favorite?: boolean
  imageUrl?: string
  isFiatConvert?: boolean // 是否显示法币折合，true是 false否
  isMarginTrade?: boolean // 是否支持杠杆
  isOpen?: string
  isPriceAlert?: boolean // 是否支持价格订阅
  last?: string
  listingTime?: number // 上市时间戳
  marginRatio?: string // 最大杠杆倍数
  sellCoinId?: number
  sellShortName?: string
  sellSymbol?: string
  totalAmount?: string
  tradeArea?: number
  tradeId?: number
  volume?: string
}>
export const getV3GetOneTradeInfo = (params?: TGetV3GetOneTradeInfoParams) => {
  return hcAxios.get<TGetV3GetOneTradeInfoResponse>(API.V3GetOneTradeInfo, { params })
}

export type TGetV3GetStarCoinThisWeekParams = any
export type TGetV3GetStarCoinThisWeekResponse = TResponse<any>
export const getV3GetStarCoinThisWeek = (params?: TGetV3GetStarCoinThisWeekParams) => {
  return hcAxios.get<TGetV3GetStarCoinThisWeekResponse>(API.V3GetStarCoinThisWeek, { params })
}

export type TGetV3GetTopTurnoverParams = any
export type TGetV3GetTopTurnoverResponse = TResponse<any>
export const getV3GetTopTurnover = (params?: TGetV3GetTopTurnoverParams) => {
  return hcAxios.get<TGetV3GetTopTurnoverResponse>(API.V3GetTopTurnover, { params })
}

export type TGetV3GetTradeTypeBySellNameParams = {
  sellName?: any // sellName
}
export type TGetV3GetTradeTypeBySellNameResponse = TResponse<any>
export const getV3GetTradeTypeBySellName = (params?: TGetV3GetTradeTypeBySellNameParams) => {
  return hcAxios.get<TGetV3GetTradeTypeBySellNameResponse>(API.V3GetTradeTypeBySellName, { params })
}

export type TPostV3GetTradeTypeBySellNameParams = {
  sellName?: any // sellName
}
export type TPostV3GetTradeTypeBySellNameResponse = TResponse<any>
export const postV3GetTradeTypeBySellName = (params?: TPostV3GetTradeTypeBySellNameParams) => {
  return hcAxios.post<TPostV3GetTradeTypeBySellNameResponse>(API.V3GetTradeTypeBySellName, params)
}

export type TGetV3InnovationTradeInfoParams = any
export type TGetV3InnovationTradeInfoResponse = TResponse<any>
export const getV3InnovationTradeInfo = (params?: TGetV3InnovationTradeInfoParams) => {
  return hcAxios.get<TGetV3InnovationTradeInfoResponse>(API.V3InnovationTradeInfo, { params })
}

export type TPostV3InnovationTradeInfoParams = any
export type TPostV3InnovationTradeInfoResponse = TResponse<any>
export const postV3InnovationTradeInfo = (params?: TPostV3InnovationTradeInfoParams) => {
  return hcAxios.post<TPostV3InnovationTradeInfoResponse>(API.V3InnovationTradeInfo, params)
}

export type TGetV3MarketAreasParams = any
export type TGetV3MarketAreasResponse = TResponse<any>
export const getV3MarketAreas = (params?: TGetV3MarketAreasParams) => {
  return hcAxios.get<TGetV3MarketAreasResponse>(API.V3MarketAreas, { params })
}

export type TPostV3MarketAreasParams = any
export type TPostV3MarketAreasResponse = TResponse<any>
export const postV3MarketAreas = (params?: TPostV3MarketAreasParams) => {
  return hcAxios.post<TPostV3MarketAreasResponse>(API.V3MarketAreas, params)
}

export type TGetV3RealMarketsParams = {
  symbol?: any // symbol
}
export type TGetV3RealMarketsResponse = TResponse<any>
export const getV3RealMarkets = (params?: TGetV3RealMarketsParams) => {
  return hcAxios.get<TGetV3RealMarketsResponse>(API.V3RealMarkets, { params })
}

export type TPostV3RealMarketsParams = {
  symbol?: any // symbol
}
export type TPostV3RealMarketsResponse = TResponse<any>
export const postV3RealMarkets = (params?: TPostV3RealMarketsParams) => {
  return hcAxios.post<TPostV3RealMarketsResponse>(API.V3RealMarkets, params)
}

export type TGetV3RealTimeTradeParams = {
  successCount?: any // successCount
  tradeId?: any // tradeId
}
export type TGetV3RealTimeTradeResponse = TResponse<any>
export const getV3RealTimeTrade = (params?: TGetV3RealTimeTradeParams) => {
  return hcAxios.get<TGetV3RealTimeTradeResponse>(API.V3RealTimeTrade, { params })
}

export type TPostV3RealTimeTradeParams = {
  successCount?: any // successCount
  tradeId?: any // tradeId
}
export type TPostV3RealTimeTradeResponse = TResponse<any>
export const postV3RealTimeTrade = (params?: TPostV3RealTimeTradeParams) => {
  return hcAxios.post<TPostV3RealTimeTradeResponse>(API.V3RealTimeTrade, params)
}

export type TGetV3TradeInfoParams = any
export type TGetV3TradeInfoResponse = TResponse<any[]>
export const getV3TradeInfo = (params?: TGetV3TradeInfoParams) => {
  return hcAxios.get<TGetV3TradeInfoResponse>(API.V3TradeInfo, { params })
}

export type TPostV3TradeInfoParams = any
export type TPostV3TradeInfoResponse = TResponse<any[]>
export const postV3TradeInfo = (params?: TPostV3TradeInfoParams) => {
  return hcAxios.post<TPostV3TradeInfoResponse>(API.V3TradeInfo, params)
}

export type TGetV3TradeInfoRankingListParams = {
  pageSize?: any // pageSize
  sortEnum?: any // sortEnum
}
export type TGetV3TradeInfoRankingListResponse = TResponse<{
  list?: any[] // 币对信息
  topic?: string // topic
}>
export const getV3TradeInfoRankingList = (params?: TGetV3TradeInfoRankingListParams) => {
  return hcAxios.get<TGetV3TradeInfoRankingListResponse>(API.V3TradeInfoRankingList, { params })
}

export type TPostV3TradeInfoRankingListParams = {
  pageSize?: any // pageSize
  sortEnum?: any // sortEnum
}
export type TPostV3TradeInfoRankingListResponse = TResponse<{
  list?: any[] // 币对信息
  topic?: string // topic
}>
export const postV3TradeInfoRankingList = (params?: TPostV3TradeInfoRankingListParams) => {
  return hcAxios.post<TPostV3TradeInfoRankingListResponse>(API.V3TradeInfoRankingList, params)
}

export type TGetSupportCoinInfoParams = {
  buyShortName?: any // buyShortName
  sellShortName?: any // sellShortName
}
export type TGetSupportCoinInfoResponse = TResponse<{
  isContractTrade?: boolean // 是否支持合约
  isMarginTrade?: boolean // 是否支持杠杆
  isSpotTrade?: boolean // 是否支持现货
}>
export const getSupportCoinInfo = (params?: TGetSupportCoinInfoParams) => {
  return hcAxios.get<TGetSupportCoinInfoResponse>(API.SupportCoinInfo, { params })
}
